<form
  class="form-container"
  name="form"
  [formGroup]="loginForm"
  (ngSubmit)="sendPasswordToUserPhone()"
>
  <div class="card-content">
    <tax-input
      class="input-field"
      [class.invalid]="error"
      labelText="organization.iin"
      [id]="'iin'"
      formControlName="iin"
      [required]="true"
      [autofocus]="true"
      [tabindex]="1"
      [minlength]="12"
      [maxlength]="12"
    ></tax-input>

    <tax-phone-input
      class="input-field"
      [class.invalid]="error"
      placeholder="login.sms.phone.placeholder"
      formControlName="phone"
      [id]="'phone'"
      [required]="true"
      [descriptionText]="'login.sms.phone.description'"
      [tabindex]="2"
    ></tax-phone-input>

    <button class="button_blue" [disabled]="loginForm.invalid" translate>login.sms.button</button>
  </div>

  <div class="card-pic">
    <svg-icon key="phone"></svg-icon>
    <div translate>login.sms.description</div>
  </div>
</form>
